import React, { Component } from 'react';
import { getCollection } from '../../apis/product-collection';
import LoaderSection from '../components/loader-section.jsx';
import WishlistProduct from '../components/wishlist-product-item.jsx';
import WishlistCSVModal from '../components/wishlist-csv-modal.jsx';
import toast from '../../components/toast';
import wishlist from '../../components/wishlist';

class WishlistLanding extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            items: []
        };

        this.handleDelete = this.handleDelete.bind(this);
    }

    componentDidMount() {
        if (wishlist.id) {
            this.load();
        }
        else {
            this.setState({
                isLoading: false
            });
        }
    }

    handleDelete() {
        this.load();
    }

    load() {
        this.setState({
            isLoading: true
        });

        getCollection(wishlist.id)
            .then(data => {
                console.log(data);
                this.setState({
                    items: data.products,
                    isLoading: false
                });
            })
            .catch(error => {
                this.setState({
                    isLoading: false
                });
                console.log(error);
                toast.error('There was an issue getting your wish list items');
            });
    }

    render() {
        let items,
            loader;

        if (!this.state.items.length && !this.state.isLoading) {
            loader = <p>You haven't added any products to your Wish List yet.</p>;
        }

        if (this.state.items.length) {
            items = <div className="row">
                <div className="col-xl-3 col-sm-6 order-xl-3">
                    <div className="panel add-margin-top">
                        <h3 className="panel-title">{this.state.items.length} Item{this.state.items.length === 1 ? '' : 's'} Total</h3>
                        <div className="panel-text">
                            <p>Download a CSV document of these products or share them via email by clicking the buttons below.</p>
                        </div>
                        <a className="btn btn-icon-left btn-csv-bg btn-block add-margin-btm add-margin-top" href={`/api/productcollection/exportcollection?collectionId=${wishlist.id}`} target="blank"><span>Download CSV</span></a>
                        <WishlistCSVModal id={wishlist.id}/>
                    </div>
                </div>
                {this.state.items.map((product, index) => (
                    <WishlistProduct key={index} {...product} colClass={`col-lg-3 col-sm-6 order-lg-${index}`} onDelete={this.handleDelete} />
                ))}
            </div>;
        }

        if (this.state.isLoading) {
            loader = <LoaderSection show={true} />;
        }

        return (
            <div class="container">
                <h1 class="heading">{this.props.title}</h1>
                {items}
                {loader}
            </div>
        );
    }
}

export default WishlistLanding;